import Distributor from './Distributor'

Vue.prototype.$state.$distributor = new Vue(Distributor)

Vue.component('distributors-table', () => import(/* webpackChunkName: "distributors-table" */ '@modulesPages/Distributor/Resources/assets/js/Tables/DistributorsTable'))

Vue.component('distributors-form', () => import(/* webpackChunkName: "distributors-form" */ '@modulesPages/Distributor/Resources/assets/js/Forms/Distributors/DistributorsForm'))

Vue.component('distributors-card', () => import(/* webpackChunkName: "distributors-card" */ '@modulesPages/Distributor/Resources/assets/js/Cards/DistributorsCard'))

Vue.component('distributors-section', () => import(/* webpackChunkName: "distributors-section" */ '@modulesPages/Distributor/Resources/assets/js/Sections/DistributorsSection'))

Vue.component('distributor-section', () => import(/* webpackChunkName: "distributor-section" */ '@modulesPages/Distributor/Resources/assets/js/Sections/DistributorSection'))


app.$Util.formattedClassName = {
	...app.$Util.formattedClassName,
	...{
		'Modules\\Distributor\\Entities\\Distributor': 'Distribuidor'
	}	
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Distributor\\Entities\\Distributor': 'distributors'
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'distributors': 'Modules\\Distributor\\Entities\\Distributor',
	}	
}